import { detect } from 'detect-browser';

export function cliLoginServerSupported() {
  const browser = detect();
  return browser ? browser.name === 'chrome' : false;
}
